import { render } from "./SampleCollectionTab.vue?vue&type=template&id=6fd778e5&scoped=true"
import script from "./SampleCollectionTab.vue?vue&type=script&lang=js"
export * from "./SampleCollectionTab.vue?vue&type=script&lang=js"

import "./SampleCollectionTab.vue?vue&type=style&index=0&id=6fd778e5&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd778e5"]])

export default __exports__